import { useAuth } from "../../../services/auth";
import { useNavigate } from "react-router-dom";

export function Logout() {
  const navigate = useNavigate();
  const { handleLogout } = useAuth();
  handleLogout();
  return navigate("/");
}
